import { Button } from '@webmotors/eleanor-ui';
import { feedbackStyles } from './feedback.styles';
import { SHARED_TEST_IDS } from '@/utils';
import type { TFeedbackConfig } from './feedback.types';

const Feedback = ({
	icon,
	title,
	description,
	action,
	secondaryAction,
	dataTestId,
	actionTestId = SHARED_TEST_IDS.FEEDBACK_ACTION_BUTTON,
	secondaryActionTestId = SHARED_TEST_IDS.FEEDBACK_SECONDARY_BUTTON
}: TFeedbackConfig) => (
	<div className={feedbackStyles.container} data-testid={dataTestId}>
		<div className={feedbackStyles.iconWrapper}>
			{icon}
		</div>

		<div className={feedbackStyles.textBlock}>
			<h2 className={feedbackStyles.title}>
				{title}
			</h2>
			<p className={feedbackStyles.description}>
				{description}
			</p>
		</div>

		{(action || secondaryAction) && (
			<div className={feedbackStyles.actionsColumn}>
				{action && (
					<Button
						variant={action.variant ?? 'situational'}
						size="medium"
						onClick={action.onClick}
						data-testid={actionTestId}
					>
						{action.label}
					</Button>
				)}
				{secondaryAction && (
					<Button
						variant={secondaryAction.variant ?? 'secondary'}
						size="medium"
						onClick={secondaryAction.onClick}
						data-testid={secondaryActionTestId}
					>
						{secondaryAction.label}
					</Button>
				)}
			</div>
		)}
	</div>
);

Feedback.displayName = 'Feedback';

export { Feedback };
